module.exports = __webpack_public_path__ + "static/media/filter-icon.6bc45fbc.svg";